// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__1rkHi","success":"Alert_success__2FJwX"};